import apiClient from './axios';

export const promoCodesApi = {
  // Отримати або призначити промокод для користувача
  getOrAssignPromoCode: (userId, discountId) => {
    return apiClient.get(`/promocodes/user/${userId}/discount/${discountId}`);
  },

  // Отримати статистику промокодів для знижки
  getPromoCodeStats: (discountId) => {
    return apiClient.get(`/promocodes/discount/${discountId}/stats`);
  },

  // Отримати всі промокоди користувача
  getUserPromoCodes: (userId) => {
    return apiClient.get(`/promocodes/user/${userId}`);
  },

  // Отримати всі промокоди для знижки (тільки для адміна)
  getPromoCodesForDiscount: (discountId) => {
    return apiClient.get(`/promocodes/discount/${discountId}`);
  },

  // Створити промокоди для знижки (тільки для адміна)
  createPromoCodes: (discountId, codes) => {
    return apiClient.post(`/promocodes/discount/${discountId}/bulk`, codes);
  },

  // Оновити промокоди для знижки (тільки для адміна)
  updatePromoCodes: (discountId, codes) => {
    return apiClient.put(`/promocodes/discount/${discountId}`, codes);
  },

  // Призначити промокод конкретному користувачу (тільки для адміна)
  assignPromoCode: (promoCodeId, userId) => {
    return apiClient.post(`/promocodes/${promoCodeId}/assign/${userId}`);
  },

  // Зняти призначення промокоду (тільки для адміна)
  unassignPromoCode: (promoCodeId) => {
    return apiClient.post(`/promocodes/${promoCodeId}/unassign`);
  }
};
